import React from 'react'

const StartupPlan = ({ data }) => {
  const phases = data?.phases || []
  const banner = data?.bottomBanner

  return (
    <div className="proposal-section">
      <div className="proposal-section__headline">{data?.headline || 'Startup Plan'}</div>
      <div className="proposal-section__accent-line" />
      <div className="proposal-startup__grid">
        {phases.map((phase, idx) => (
          <div className="proposal-startup__phase" key={idx}>
            {phase.label && (
              <div className="proposal-startup__phase-label">{phase.label}</div>
            )}
            {phase.title && (
              <div className="proposal-startup__phase-title">{phase.title}</div>
            )}
            {phase.tasks && phase.tasks.length > 0 && (
              <ul className="proposal-startup__tasks">
                {phase.tasks.map((task, tIdx) => (
                  <li className="proposal-startup__task" key={tIdx}>{task}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      {banner?.enabled && (
        <div className="proposal-startup__banner">
          {banner.stats && banner.stats.length > 0 && (
            <div className="proposal-startup__banner-stats">
              {banner.stats.map((stat, i) => (
                <div className="proposal-startup__banner-stat" key={i}>
                  <div className="proposal-startup__banner-stat-value">{stat.value}</div>
                  <div className="proposal-startup__banner-stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          )}
          {banner.text && (
            <div className="proposal-startup__banner-text">{banner.text}</div>
          )}
        </div>
      )}
    </div>
  )
}

export default StartupPlan
